import { mutator } from 'satcheljs';
import getAppHostStore from '../store/store';
import { onOpenMOSAppWithContext } from '../actions/onOpenMOSAppWithContext';
import { setSelectedApp } from 'owa-appbar-state';
import { updateHostedApp } from '../actions/updateHostedApp';

mutator(updateHostedApp, actionMessage => {
    const { app } = actionMessage;
    getAppHostStore().hostedApp = app;
    getAppHostStore().selectedEntityId = app?.staticTabs[0].entityId || '';
    getAppHostStore().subEntityId = '';
});

mutator(onOpenMOSAppWithContext, actionMessage => {
    const { appId, app, entityId, subEntityId } = actionMessage;
    if (app) {
        setSelectedApp(appId);
        getAppHostStore().hostedApp = app;
        getAppHostStore().selectedEntityId = entityId;
        getAppHostStore().subEntityId = subEntityId;
    }
});
